<script lang="ts">
	import { format } from 'svelte-i18n';
	import { ControlsContainer, TemperatureWheel } from '@Shelly/shelly-design-system';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';

	export let editableObject;

	const { unit } = editableObject.schedule;
	const min = unit === 'F' ? 41 : 5;
	const max = unit === 'F' ? 95 : 35;
	const step = unit === 'F' ? 1 : 0.5;
	console.warn(editableObject);
	//ToDo finish schedules!!!!

	const a11yProps = {
		tempWheelAriaLabel: $format('label_temperature', { default: 'Temperature' }),
		thumbAriaLabel: $format('label_temperature_thumb', { default: 'Temperature thumb' }),
		incrementBtnAriaLabel: $format('button_increase_temperature', {
			default: 'Increase temperature',
		}),
		decrementBtnAriaLabel: $format('button_decrease_temperature', {
			default: 'Decrease temperature',
		}),
		spinnerAriaLabel: $format('label_temperature_spinner', { default: 'Temperature spinner' }),
	};
</script>

<ControlsContainer color={$showNewLayout ? 'color-0' : undefined}>
	<svelte:fragment slot="first">
		<TemperatureWheel
			{a11yProps}
			type="temp"
			{min}
			{max}
			{step}
			valuePrefix={`°${editableObject.schedule.unit}`}
			bind:value={editableObject.schedule.target_C}
		/>
	</svelte:fragment>
</ControlsContainer>
